<template>
    <body class="mainbody">
      <!--主页-->
      <div class="MainPage" v-show="show">
        <!--主体部分的导航-->

        <div class="mui-bar mui-bar-nav MainPage-top" style="background-color: #767ec7;color: #FFFFFF;font-size: 18px;">
          <div class="">
            <span>工作联络</span>
          </div>
          <!--<div class="searchaddbtn" style="">-->
            <!--<div>-->
              <!--<i class="fa fa-search" id="searchbtn"></i>-->
            <!--</div>-->
            <!--<div>-->
              <!--<i class="fa fa-plus-square-o" id="msgboxbtn"></i>-->
            <!--</div>-->
          <!--</div>-->
          <!--发起群聊的框-->
          <div class="chatMessageBox" style="display: none;">
            <div id="chatgroupbtn">
              <div class="flex-1">
                <i class="fa fa-comment"></i>
              </div>
              <div class="flex-3">
                <span>发起群聊</span>
              </div>
            </div>
            <i></i>
          </div>
        </div>

        <!--主体-->
        <div class="mui-content MainPage-body">
          <!--聊天列表页-->
          <div class="ChatListPage" style="display:block;">
            <!--<div style="height: 50px;width: 100%;background-color: #1F6FB5">dk</div>-->
            <!--<div style="height: 50px;width: 100%;background-color: #767ec7">聊天</div>-->
            <div v-for="item in groupList" class="list-item toChatPage" v-on:click="toMain2Chat(item)">
              <div class="list-item-left">
                <img src="../../static/WeChat/images/userimgtwo.png" alt="">
              </div>
              <div class="list-item-right">
                <!--<div>-->
                  <!--<h4>{{item.group_name}}</h4>-->
                  <!--<div class="chat-content">-->
                    <!--{{item.last_message}}-->
                  <!--</div>-->
                <!--</div>-->
                <!--<div class="list-item-time">-->
                  <!--<span>{{item.last_time}}</span>-->
                <!--</div>-->
                <div style="display: flex;">
                  <h4 class="flex-1">{{item.group_name}}</h4>
                  <div class="flex-2 list-item-time"><span>{{item.last_time}}</span></div>
                </div>
                <div class="chat-content">
                  <span>{{item.last_message}}</span>
                </div>
              </div>
            </div>
          </div>
          <!--通讯录页-->
          <div class="AddressBookPage bg-blue" style="display: none;">
            <div id="sliderbtn">
              <div class="slider-content">
                <ul>
                  <li id="a">
                    <a name="" class="title">A</a>
                    <ul>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>
                          <!--<input type="checkbox" name="" id="" value="" />-->
                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>

                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Alex</span>
                          <i class="fa fa-check-square-o"></i>
                        </a>
                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>

                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>
                      </li>
                      <li><a href="~/Scripts/#">Apple</a></li>
                      <li><a href="~/Scripts/#">Arthur</a></li>
                      <li><a href="~/Scripts/#">Ashley</a></li>
                    </ul>
                  </li>
                  <li id="b">
                    <a name="" class="title">B</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="c">
                    <a name="" class="title">c</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="d">
                    <a name="" class="title">d</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="e">
                    <a name="" class="title">E</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="f">
                    <a name="" class="title">f</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="g">
                    <a name="" class="title">g</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="h">
                    <a name="" class="title">h</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="i">
                    <a name="" class="title">i</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="j">
                    <a name="" class="title">j</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="k">
                    <a name="" class="title">k</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="l">
                    <a name="" class="title">l</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="m">
                    <a name="" class="title">m</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="n">
                    <a name="" class="title">n</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="o">
                    <a name="" class="title">o</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="p">
                    <a name="" class="title">p</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="q">
                    <a name="" class="title">q</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="r">
                    <a name="" class="title">r</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="s">
                    <a name="" class="title">s</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="t">
                    <a name="" class="title">t</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="u">
                    <a name="" class="title">u</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="v">
                    <a name="" class="title">v</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="w">
                    <a name="" class="title">w</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="x">
                    <a name="" class="title">x</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="y">
                    <a name="" class="title">y</a>
                    <ul>
                      <li>
                        <a href="~/Scripts/#">易阳科技</a>

                      </li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="z">
                    <a name="" class="title">z</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <!--主体下部导航栏部分-->
        <!--<div class="MainPage-nav" >-->
          <!--<div class="active flex-1" id="wechatbtn">-->
            <!--<i class="fa fa-comment"></i>-->
            <!--<div>微信</div>-->
          <!--</div>-->
          <!--&lt;!&ndash;<div class="flex-1" id="addressbookbtn">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="fa fa-address-book-o"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;<div>通讯录</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--<div class="flex-1">-->

          <!--</div>-->
          <!--<div class="flex-1"></div>-->
        <!--</div>-->
      </div>
      <!--发起群聊页-->
      <div class="GroupChatPage" style="display: none;">
        <!--头部-->
        <div class="mui-bar mui-bar-nav GroupChatPage-top">
          <a class="mui-icon mui-icon-left-nav mui-pull-left" id="backMainpagebtn"></a>
          <div class="GroupChatPage-top-left flex-1">
            <span>发起群聊</span>
          </div>
          <div class="GroupChatPage-top-right flex-1">
            <!--<i class="fa fa-ellipsis-h" id="operatorbtn"></i>-->
            <button type="button" class="mui-btn mui-btn-primary">确定&nbsp;(<span>12</span>)</button>
          </div>
        </div>
        <!--内容-->
        <div class="GroupChatPage-body">
          <div class="searchinput">
            <div>
              <i class="fa fa-search"></i>
            </div>
            <div class="flex-1">
              <input type="text" name="" id="sliderinput" value="搜索" />
            </div>
          </div>
          <!--通讯录-->
          <div class="searchslider clear" style="display: block;padding: 0px;margin-bottom: 0px;">
            <div id="slider" class="">
              <div class="slider-content">
                <ul>
                  <li id="a">
                    <a name="" class="title">A</a>
                    <ul>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>
                          <!--<input type="checkbox" name="" id="" value="" />-->
                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>

                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Alex</span>
                          <i class="fa fa-check-square-o"></i>
                        </a>
                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>

                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>
                      </li>
                      <li><a href="~/Scripts/#">Apple</a></li>
                      <li><a href="~/Scripts/#">Arthur</a></li>
                      <li><a href="~/Scripts/#">Ashley</a></li>
                    </ul>
                  </li>
                  <li id="b">
                    <a name="" class="title">B</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="c">
                    <a name="" class="title">c</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="d">
                    <a name="" class="title">d</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="e">
                    <a name="" class="title">E</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="f">
                    <a name="" class="title">f</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="g">
                    <a name="" class="title">g</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="h">
                    <a name="" class="title">h</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="i">
                    <a name="" class="title">i</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="j">
                    <a name="" class="title">j</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="k">
                    <a name="" class="title">k</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="l">
                    <a name="" class="title">l</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="m">
                    <a name="" class="title">m</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="n">
                    <a name="" class="title">n</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="o">
                    <a name="" class="title">o</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="p">
                    <a name="" class="title">p</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="q">
                    <a name="" class="title">q</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="r">
                    <a name="" class="title">r</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="s">
                    <a name="" class="title">s</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="t">
                    <a name="" class="title">t</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="u">
                    <a name="" class="title">u</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="v">
                    <a name="" class="title">v</a>
                    <ul>
                      <li><a href="~/Scripts/#">Barry</a></li>
                      <li><a href="~/Scripts/#">Becky</a></li>
                      <li><a href="~/Scripts/#">Biff</a></li>
                      <li><a href="~/Scripts/#">Billy</a></li>
                      <li><a href="~/Scripts/#">Bozarking</a></li>
                      <li><a href="~/Scripts/#">Bryan</a></li>
                    </ul>
                  </li>
                  <li id="w">
                    <a name="" class="title">w</a>
                    <ul>
                      <li><a href="~/Scripts/#">Calista</a></li>
                      <li><a href="~/Scripts/#">Cathy</a></li>
                      <li><a href="~/Scripts/#">Chris</a></li>
                      <li><a href="~/Scripts/#">Cinderella</a></li>
                      <li><a href="~/Scripts/#">Corky</a></li>
                      <li><a href="~/Scripts/#">Cypher</a></li>
                    </ul>
                  </li>
                  <li id="x">
                    <a name="" class="title">x</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="y">
                    <a name="" class="title">y</a>
                    <ul>
                      <li>
                        <a href="~/Scripts/#">易阳科技</a>

                      </li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                  <li id="z">
                    <a name="" class="title">z</a>
                    <ul>
                      <li><a href="~/Scripts/#">damien</a></li>
                      <li><a href="~/Scripts/#">danny</a></li>
                      <li><a href="~/Scripts/#">denver</a></li>
                      <li><a href="~/Scripts/#">devon</a></li>
                      <li><a href="~/Scripts/#">doug</a></li>
                      <li><a href="~/Scripts/#">dustin</a></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--搜索页-->
          <div class="searchPageslider" style="display: none;padding: 0px;margin-bottom: 0px;">
            <div class="sliderdst">
              <div class="slider-content">
                <ul>
                  <li class="selected">
                    <a name="" class="title">A</a>
                    <ul>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>
                          <!--<input type="checkbox" name="" id="" value="" />-->
                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>

                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Alex</span>
                          <i class="fa fa-check-square-o"></i>
                        </a>
                      </li>
                      <li>
                        <a href="~/Scripts/#">
                          <span>Adam</span>

                          <!--未选中-->
                          <i class="fa fa-square-o"></i>
                        </a>
                      </li>
                      <li><a href="~/Scripts/#">Apple</a></li>
                      <li><a href="~/Scripts/#">Arthur</a></li>
                      <li><a href="~/Scripts/#">Ashley</a></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--聊天界面页-->
      <div class="ChatPage" id="chatpage" style="display: none;" v-show="chatPage.show">
        <!--头部-->
        <div class="mui-bar mui-bar-nav ChatPage-top" style="background-color: #767ec7;color: #FFFFFF;font-size: 18px;">
          <a class="mui-icon mui-icon-left-nav mui-pull-left" style="color: white;" id="backtop" v-on:click="toChat2Main()"></a>
          <div class="ChatPage-top-left flex-3">
            <span>{{chatPage.group_name}}</span>
          </div>
          <div class="ChatPage-top-right flex-1">
            <i class="fa fa-ellipsis-h" id="operatorbtn" @click="toChat2ChatMessage()"></i>
          </div>
        </div>
        <!--内容-->
        <div class="ChatPage-body"  v-bind:style="chatPage.contentShow? 'bottom:130px;':'bottom:52px;'">
          <!--左边-->

          <div class="clear" v-for="item in chatPage.messageList" v-bind:class="item.qy_uid==qy_uid? 'mine-chat':'other-chat'">
            <!--昵称-->
            <div class="nickname">
              <span>{{item.username}}</span>
            </div>
            <!--消息-->
            <div class="messageframe">
              <p v-if="item.m_type=='01'">{{item.m_content}}</p>
              <p v-else-if="item.m_type=='02'"><a v-bind:href="'/Webchat/DownloadFile?filename='+item.m_content+'&group_id='+chatPage.group_id">{{item.m_content}}</a></p>
              <p v-else-if="item.m_type=='03'" @click="previewImage(item.m_content,chatPage.group_id)"><img v-bind:href="'/Webchat/DownloadImg?filename='+item.m_content+'&group_id='+chatPage.group_id" v-bind:src="'/Webchat/DownloadImg?filename='+item.m_content+'&group_id='+chatPage.group_id" width=100px/></p>
              <i></i>
            </div>
          </div>

        </div>
        <!--脚-->
        <div class="ChatPage-nav">
          <div class="nav-btn">
            <div class="wt-52 addfile" id="addicons" @click="chatPage.contentShow = !chatPage.contentShow"><i class="fa fa-plus-circle"></i></div>
            <div class="flex-1 addinput">
              <input type="" name="" id="" v-model="chatPage.message" />
            </div>
            <div class="wt-70 btnsend">
              <button type="button" class="mui-btn mui-btn-primary btn-blue" v-on:click="sendMessage()">发送</button>
            </div>
          </div>
          <div class="more-icon-content" id="iconsdiv" style="display: none;" v-show="chatPage.contentShow">
            <!--<div class="fileaddbtn" @click="toChatPage2MobileSave()">-->
              <!--<i class="fa fa-folder-open"></i>-->
            <!--</div>-->
            <div class="fileaddbtn" @click="uploadImage()">
              <i class="fa fa-file-picture-o"></i>
            </div>
          </div>
        </div>
      </div>
      <!--聊天信息页-->
      <div class="ChatMessagePage" style="display: none;"  v-show="chatMessagePage.show">
        <div class="mui-bar mui-bar-nav ChatMessagePage-top" style="background-color: #767ec7;color: #FFFFFF;font-size: 18px;">
          <a class="mui-icon mui-icon-left-nav mui-pull-left" style="color:#FFFFFF;" id="backtopChatPage" @click="toChatMessage2Chat()"></a>
          <div class="ChatMessagePage-top-left flex-1">
            <span>联络信息</span>
          </div>
        </div>
        <!--内容-->
        <div class="ChatMessagePage-body">
          <div class="peoplecollect">
            <div class="clear">
              <div v-for="(item,index) in chatMessagePage.userList">
                <img src="../../static/WeChat/images/userimgtwo.png" alt="" />
                <div>
                  <span>{{item.username}}</span>
                </div>
              </div>
              <div style="display: none;" >
                <img src="images/plus.png"/>
              </div>
            </div>
          </div>
          <!--<div class="searchMessage">-->
                <!--<span>-->
                    <!--查找聊天记录-->
                <!--</span>-->
            <!--<i class="fa fa-angle-right"></i>-->
          <!--</div>-->
          <!--<div class="outflockbtn">-->
            <!--<button>删除并退出</button>-->
          <!--</div>-->
        </div>

      </div>
      <!--手机存储页-->
      <div class="MobileSavePage" style="display: none;" v-show="mobileSavePage.show">
        <!--头部-->
        <div class="mui-bar mui-bar-nav MobileSavePage-top clear">
          <a class="mui-icon mui-icon-left-nav mui-pull-left" id="filebackbtn" @click="toMobileSave2ChatPage()"></a>
          <div class="MobileSavePage-top-left flex-1">
            <span>发送文件</span>
          </div>
          <div class="MobileSavePage-top-right flex-1">
            <!--<i class="fa fa-ellipsis-h" id="operatorbtn"></i>-->
            <button type="button" class="mui-btn mui-btn-primary" @click="uploadFile()">确定&nbsp;(<span>12</span>)</button>
          </div>
        </div>

        <div class="MobileSavePage-body">
          <form id="fileUploadForm" enctype="multipart/form-data">
            <input id="fileUpload" name="FileData" type="file" accept=".txt,.doc,.docx,.xls,.xlsx">
          </form>
          <div class="item-content">
            <div class="file-img">
              <img src="images/user.png" />
            </div>
            <div class="file-name flex-1">
              <div id="">
                <h3>XXXXXXX</h3>
              </div>
              <div class="chat-content">
                <span style="margin-right: 10px;">1.7M</span>
                <span>2019/02/21</span>
              </div>
              <i class="fa fa-square-o"></i>
            </div>

          </div>
          <div class="item-content">
            <div class="file-img">
              <img src="images/user.png" />
            </div>
            <div class="file-name flex-1">
              <div id="">
                <h3>XXXXXXX</h3>
              </div>
              <div class="chat-content">
                <span style="margin-right: 10px;">1.7M</span>
                <span>2019/02/21</span>
              </div>
              <i class="fa fa-check-square-o"></i>
            </div>
          </div>
          <div class="item-content">
            <div class="file-img">
              <img src="images/user.png" />
            </div>
            <div class="file-name flex-1">
              <div id="">
                <h3>XXXXXXX</h3>
              </div>
              <div class="chat-content">
                <span style="margin-right: 10px;">1.7M</span>
                <span>2019/02/21</span>
              </div>
              <i class="fa fa-square-o"></i>
            </div>
          </div>
          <div class="item-content">
            <div class="file-img">
              <img src="images/user.png" />
            </div>
            <div class="file-name flex-1">
              <div id="">
                <h3>XXXXXXX</h3>
              </div>
              <div class="chat-content">
                <span style="margin-right: 10px;">1.7M</span>
                <span>2019/02/21</span>
              </div>
              <i class="fa fa-check-square-o"></i>
            </div>
          </div>
          <div class="item-content">
            <div class="file-img">
              <img src="images/user.png" />
            </div>
            <div class="file-name flex-1">
              <div id="">
                <h3>XXXXXXX</h3>
              </div>
              <div class="chat-content">
                <span style="margin-right: 10px;">1.7M</span>
                <span>2019/02/21</span>
              </div>
              <i class="fa fa-square-o"></i>
            </div>
          </div>
        </div>

      </div>
      <!--搜索页-->
      <div class="SearchPage" style="display:none;">
        <div class="mui-bar mui-bar-nav SearchPage-top">
          <a class="mui-icon mui-icon-left-nav mui-pull-left" id="searchbackbtn"></a>
          <div class="SearchPage-top-left flex-1">
            <input type="text" value="搜索">
          </div>
        </div>
        <div class="SearchPage-body">
          <div class="searchdivone" style="display:none;">
            <div class="search-specified-content">
              <span>搜索指定的内容</span>
            </div>
          </div>
          <div class="searchdivtwo" style="display:block;padding:0px;">
            <h3 class="searchpeople">联系人</h3>
            <div class="list-item">
              <div class="list-item-left">
                <img src="images/user.png" alt="">
              </div>
              <div class="list-item-right">
                <div>
                  <h4 class="connect-h4">某部门</h4>
                </div>
              </div>
            </div>
            <div class="list-item" style="margin-top: 10px;">
              <div class="list-item-left">
                <img src="images/user.png" alt="">
              </div>
              <div class="list-item-right">
                <div>
                  <h4 class="connect-h4">某部门</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
</template>
<script>
  const MESSAGETYPE_TEXT = "01"
  const MESSAGETYPE_FILE = "02"
  const MESSAGETYPE_IMAG = "03"
  export default {
    name: "main",
    data() {
      return {
        chat: null,
        hub: null,
        connected: false,

        uname: "",//当前用户名
        qy_uid: "",//当前用户id
        groupList: [],
        show: true,
        chatPage: {
          group_id: "",
          group_name: "",
          messageList: [],
          show: false,
          message: "",
          contentShow: false,
        },
        chatMessagePage:{
          show: false,
          userList:[],
        },
        mobileSavePage:{
          show: false,
        }

      }
    },
    created() {
      $('#slider').sliderNav();
      $('#sliderbtn').sliderNav();
      this.nyy.wxInit();
    },
    mounted() {
      this.hub = $.connection.hub
      this.chat = $.connection.qYHub
      const v = this;
      v.nyy.doPost("/Webchat/Init", {}, function (result) {
        if (result.status) {

          v.qy_uid = result.data.userid;
          v.uname = result.data.uname;
          v.hub.qs = { "qy_uid": v.qy_uid };

          v.getGroups();
          v.chat.client.newMessage = function (group_id, type, qy_uid, username, message, sendtime) {
            if(qy_uid==v.qy_uid){
              v.chatPage.message="";
            }
            //mui.toast("收到新消息");
            if (v.chatPage.group_id == group_id) {
              v.chatPage.messageList.push({
                "m_type": type,
                "qy_uid": qy_uid,
                "username": username,
                "m_content": message,
                "sendtime": sendtime
              });
              v.scroll2bottom();
            }
            $.each(v.groupList, function (index, group) {
              if (group.group_id == group_id) {
                if(type==MESSAGETYPE_TEXT){
                  group.last_message = username + "：" + message;
                }
                else if(type==MESSAGETYPE_FILE){
                  group.last_message = username + "：【文件】";
                }
                else if(type==MESSAGETYPE_FILE){
                  group.last_message = username + "：【图片】";
                }
                group.last_time = sendtime;
              }

            })

          };
          v.connectServer();
          v.hub.disconnected(function () {
            v.connected = false;
            mui.toast("与服务器断开连接")
            setTimeout(function () {
              mui.toast("尝试重新连接")
              v.hub.start().done(
                function (info) {
                  v.connected = true;
                  mui.toast("重连服务器成功")
                  v.chat.client.newMessage = function (group_id, type, qy_uid, username, message, sendtime) {
                    //mui.toast("收到新消息");
                    if (v.chatPage.group_id == group_id) {
                      v.chatPage.messageList.push({
                        "m_type": type,
                        "qy_uid": qy_uid,
                        "username": username,
                        "m_content": message,
                        "sendtime": sendtime
                      });
                      v.scroll2bottom();
                    }

                    $.each(v.groupList, function (index, group) {
                      if (group.group_id == group_id) {
                        if(type==MESSAGETYPE_TEXT){
                          group.last_message = username + "：" + message;
                        }
                        else if(type==MESSAGETYPE_FILE){
                          group.last_message = username + "：【文件】";
                        }
                        else if(type==MESSAGETYPE_FILE){
                          group.last_message = username + "：【图片】";
                        }
                        group.last_time = sendtime;
                      }

                    })
                  };
                }
              ).fail(function () {
                mui.toast("重连服务器失败")
              });
            }, 5000); // Restart connection after 5 seconds.
          });
        }
      })
    },
    activated() {
      this.show = true;
      this.chatPage.show = false;
      this.chatPage.contentShow = false;
      this.chatMessagePage.show = false;
    },
    methods: {
      connectServer() {
        const v = this;

        //mui.toast("准备连接到聊天服务器...")

        v.hub.start({ jsonp: true }).done(
          function (info) {
            v.connected = true;
            mui.toast("连接服务器成功")
          }
        ).fail(function () {
          v.connected = false;
          mui.toast("连接服务器失败")
        });
      },
      getGroups () {
        const v = this;
        v.nyy.doPost("/Webchat/GetGroups", {}, function (result) {
            if (result.status) {
              v.groupList = result.data
            }

        })
      },
      sendMessage() {

        if (this.chatPage.message != "") {

          this.chat.server.newMessage(this.chatPage.group_id, MESSAGETYPE_TEXT, this.chatPage.message);
        } else {
          mui.toast("发送内容不能为空")
          return;
        }
      },
      getMessages(group_id) {
        const v = this
        const starttime = new Date().Format("yyyy-MM-dd hh:mm:ss");
        if (v.chatPage.messageList.length > 0) {
          const starttime = v.chatPage.messageList[0].sendtime;
        }
        v.nyy.doPost("/Webchat/DropDown", { "group_id":group_id, "starttime": starttime }, function (result) {
          if (result.status) {
            v.chatPage.messageList = result.data.reverse().concat(v.chatPage.messageList);
            v.scroll2bottom();
          }
        })
      },
      getGroupUsers(group_id){
        const v = this
        v.nyy.doPost("/Webchat/GetGroupUsers", { "group_id": group_id}, function (result) {
          if (result.status) {
            v.chatMessagePage.userList = result.data;
          }
        })
      },
      scroll2bottom(){
        this.$nextTick(function () {
          $(".ChatPage-body").scrollTop($(".ChatPage-body")[0].scrollHeight)
        })
      },
      toChat2Main() {
        this.show = true;
        this.chatPage.show = false;
        this.chatMessagePage.show = false;
        this.chatPage.messageList = [];
        this.chatPage.message = "";
      },
      toMain2Chat(item) {
        this.show = false;
        this.chatPage.show = true
        this.chatMessagePage.show = false;
        this.chatPage.group_id = item.group_id;
        this.chatPage.group_name = item.group_name;
        this.chatPage.messageList = [];
        this.getMessages(this.chatPage.group_id);
      },
      toChat2ChatMessage(){
        this.chatMessagePage.show = true;
        this.show = false;
        this.chatPage.show = false;
        this.getGroupUsers(this.chatPage.group_id);
      },
      toChatMessage2Chat(){
        this.chatMessagePage.show = false;
        this.show = false;
        this.chatPage.show = true;
      },
      toChatPage2MobileSave (){
        this.chatPage.show = false;
        this.mobileSavePage.show = true;
      },
      toMobileSave2ChatPage(){
        this.chatPage.show = true;
        this.mobileSavePage.show = false;
      },
      uploadFile(){
        //alert("提交文件");
        const v= this;
        v.nyy.upload("/Webchat/UploadFile",{"group_id":v.chatPage.group_id},$('#fileUploadForm'),function(result){
          if(result.status){
            v.chat.server.newMessage(v.chatPage.group_id, MESSAGETYPE_FILE, result.data.filename);
          }
        });
      },
      uploadImage(){
        const v = this;
        wx.chooseImage({
          count: 1, // 默认9
          success: function (res) {
            const localIds = res.localIds; // 返回选定照片的本地ID列表，
            // andriod中localId可以作为img标签的src属性显示图片；
            // 而在IOS中需通过上面的接口getLocalImgData获取图片base64数据，从而用于img标签的显示
            wx.uploadImage({
              localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function (res) {
                const serverId = res.serverId; // 返回图片的服务器端ID
                //alert(serverId);
                v.nyy.doPost("/Webchat/UploadImg",{"group_id":v.chatPage.group_id,"mediaId":serverId},function(result){
                  if(result.status){
                    v.chat.server.newMessage(v.chatPage.group_id, MESSAGETYPE_IMAG, result.data.filename);
                  }
                });
              }
            });
          }
        })
      },
      previewImage(m_content,group_id){
        wx.previewImage({
          current: '/Webchat/DownloadImg?filename='+m_content+'&group_id='+group_id, // 当前显示图片的http链接
          urls: ['/Webchat/DownloadImg?filename='+m_content+'&group_id='+group_id] // 需要预览的图片http链接列表
        });
      }
    }
  }
</script>

<style scoped>
  @import "../../static/WeChat/css/reset.css";
  @import "../../static/WeChat/css/comm.css";
  @import "../../static/WeChat/css/MainPage.css";

  @import "../../static/WeChat/lib/css/mui.css";
/*   @import "../../static/WeChat/lib/css/font-awesome.min.css"; */

  @import "../../static/WeChat/css/ChatListPage.css";
  @import "../../static/WeChat/css/ChatPage.css";
  @import "../../static/WeChat/css/ChatMessagePage.css";
  @import "../../static/WeChat/css/AddressBookPage.css";
  @import "../../static/WeChat/lib/css/silidernav.css";
  @import "../../static/WeChat/css/GroupChatPage.css";
  @import "../../static/WeChat/css/SearchPage.css";
  @import "../../static/WeChat/css/FilePage.css";
  /*@import "../../static/WeChat/images/FilePage.css";*/
  [contenteditable="true"], input, textarea {
    -webkit-user-select: auto !important;
    -khtml-user-select: auto !important;
    -moz-user-select: auto !important;
    -ms-user-select: auto !important;
    -o-user-select: auto !important;
    user-select: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/weChat.vue